export default "__VITE_ASSET__21200f99__"